<template>
    <div>
      <h1>Ride details</h1>
    </div>
  </template>
  
  <script setup>
  </script>